export default "__VITE_ASSET__AKq8JazL__"